import { Resolution } from '@/modules/shared/types';
import type { WidgetConfig } from '@/modules/ctx-dashboard';
import { WidgetType } from '@/modules/ctx-dashboard';
import type { WidgetPreset } from '@/components/widget-wizard';

export default class TableCommissionsEvu implements WidgetPreset {

    public readonly name: string = 'commissions-evu';
    public readonly type: WidgetType = WidgetType.Commissions;
    public readonly quickAdd: boolean = false;
    public readonly order: number = 20;
    public readonly metrics: string[] = [];

    public async createWidget(params: { portfolio: string; dashboard: string }): Promise<WidgetConfig> {
        return {
            key: '',
            portfolioKey: params.portfolio,
            dashboardKey: params.dashboard,
            order: 0,
            config: {
                useSingleResourceList: true,
            },
            type: this.type,
            preset: this.name,
            title: '',
            generatedTitle: '',
            intervalName: 'this-year-complete',
            intervalTo: new Date(),
            intervalFrom: new Date(),
            resolution: Resolution.Monthly,
            axis: [{
                unit: '',
                name: '',
                config: {},
                metrics: [],
            }],
        };
    }
}
